import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class PopoverService {
  private currentPopoverIndex: number | null = null;

  isPopoverVisible(index: number): boolean {
    return this.currentPopoverIndex === index;
  }

  showPopover(index: number): void {
    this.currentPopoverIndex = index;
  }

  hidePopover(index: number): void {
    if (this.currentPopoverIndex === index) {
      this.currentPopoverIndex = null;
    }
  }
  getCurrentPopoverIndex(): number | null {
    return this.currentPopoverIndex;
  }
}
